import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  standalone: true,
  name: 'controlName'
})
export class ControlNamePipe implements PipeTransform {
  transform(control: AbstractControl): string | null {
    if (!control || !control.parent) {
      return null;
    }
    const formGroup = control.parent.controls;
    return Object.keys(formGroup).find(name => control === formGroup[name]) || null;
  }
}
